
import { defineComponent, PropType } from "vue";
import { MigrationStepDef, MigrationStepState } from "./types";

const RANKS_PLACEHOLDER = `[
  { "id": "INITIAL",  "name": "Initial",  "priority": 100, "status": "active" },
  { "id": "FOUNDER",  "name": "Founder",  "priority": 200, "status": "active" },
  { "id": "SENTINEL", "name": "Sentinel", "priority": 999, "status": "active", "isSentinel": true }
]`;

export default defineComponent({
  name: "StepAuto",
  props: {
    step: { type: Object as PropType<MigrationStepDef>, required: true },
    runId: { type: String, required: true },
    unlocked: { type: Boolean, required: true },
    busy: { type: Boolean, required: true },
    /**
     * CUÁL de los dos botones está trabajando, no si «algo» trabaja.
     *
     * `busy` deshabilita los dos a la vez, así que por sí solo no distingue el
     * paso que corre del que espera: los pasos automáticos son los más largos
     * —el gate, la traducción, el clon— y sin esto la pantalla se queda muda
     * justo donde más tarda, que es cuando uno se pregunta si pulsó bien.
     *
     * Los decide el padre con la MISMA función que construye la clave de la
     * acción (`autoAction`), para que no haya dos sitios armando esa cadena.
     */
    runningDry: { type: Boolean, default: false },
    runningRun: { type: Boolean, default: false },
    state: {
      type: Object as PropType<MigrationStepState | undefined>,
      default: undefined,
    },
  },
  emits: ["run"],
  data() {
    return {
      ranksJson: "",
      mapJson: "",
      ranksPlaceholder: RANKS_PLACEHOLDER,
    };
  },
  computed: {
    /** Payload is parsed HERE so a typo fails before it reaches the callable. */
    payload(): { data?: unknown; error?: string } {
      try {
        // Los ids van con los del backend y con los `v-if` de la plantilla. Son
        // claves estables: ya no se renumeran, y la suite de backend comprueba que
        // las que se nombran aquí existan de verdad.
        if (this.step.id === "load-new-ranks--c") {
          if (!this.ranksJson.trim()) return { data: { ranks: [] } };
          return { data: { ranks: JSON.parse(this.ranksJson) } };
        }
        if (this.step.id === "remap-rank-refs--c") {
          if (!this.mapJson.trim()) return { data: { map: {} } };
          return { data: { map: JSON.parse(this.mapJson) } };
        }
        return { data: {} };
      } catch (e) {
        return { error: (e as Error).message };
      }
    },
    parseError(): string | undefined {
      return this.payload.error;
    },
  },
  methods: {
    emitRun(dryRun: boolean): void {
      if (this.parseError) return;
      this.$emit("run", {
        stepId: this.step.id,
        dryRun,
        data: this.payload.data,
      });
    },
  },
});
